<template>
  <a
    v-if="isAnchor"
    @click="buttonClicked"
    class="rent-button"
    :class="dynamicClasses"
    :href="href"
    :target="target"
  >
    <small-loading-animation v-if="loading" />
    <template v-if="!loading">
      <slot name="default" />
      <slot name="customIcon">
        <!--
        <svg
          v-if="!iconless"
          class="default-icon"
        >
          <use xlink:href="#icon-arrow2"></use>
        </svg>
        -->
      </slot>
    </template>
  </a>
  <button
    :disabled="buttonDisabled"
    @click="buttonClicked"
    :class="dynamicClasses"
    class="rent-button"
    type="button"
    v-else
  >
    <small-loading-animation v-if="loading" />
    <template v-if="!loading">
      <slot name="default" />
    </template>
  </button>
</template>

<script>
import SmallLoadingAnimation from './SmallLoadingAnimation'

export default {
  name: 'RentButton',
  components: {
    SmallLoadingAnimation,
  },
  props: {
    isAnchor: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: '#0',
    },
    iconless: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    grey: {
      type: Boolean,
      default: false,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isOrange: {
      type: Boolean,
      default: false,
    },
    target: {
      type: String,
      default: '_self',
    },
  },
  computed: {
    buttonDisabled() {
      return this.isDisabled || this.loading
    },
    dynamicClasses() {
      return {
        '-grey': this.grey,
        '-white': this.isWhite,
        '-orange': this.isOrange,
      }
    },
  },
  methods: {
    buttonClicked() {
      this.$emit('buttonclicked')
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../sass/config/vars";
@import "../../../sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.rent-button {
  align-content: stretch;
  align-items: center;
  background-color: $black;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  flex: 1;
  font-family: $f-graphie-bold;
  font-size: 1.8rem;
  height: 5.6rem;
  justify-content: center;
  line-height: 2.2rem;
  margin-bottom: 2rem;
  max-width: 420px;
  min-height: 5.6rem;
  padding: 0 3rem;
  position: relative;
  text-decoration: none;
  transition: opacity 250ms ease-out;
  transition: background-color 250ms ease-out;
  width: 100%;

  @include teq-breakpoint($large) {
    &:first-child {
      margin-right: 2rem;
    }
  }

  &:disabled {
    color: #666;
    cursor: auto;
  }

  &:hover {
    background-color: $gray;
    //border: 1px solid black;
    color: black;
    transition: background-color 250ms ease-in;
  }

  &:focus {
    background-color: $orange;
    border: 1px solid $orange;
    color: white;
  }

  &.-grey {
    background-color: white;
    //background-color: $c-alto;
    border: 1px solid black;
    color: black;

    &:hover {
      background-color: $gray;
      //background-color: $c-alto;
      border: 1px solid $gray;
      color: black;
    }

    &:focus {
      background-color: $orange;
      border: 1px solid $orange;
      color: white;
    }
  }

  &.-orange {
    background-color: $orange;
    //background-color: $c-alto;
    border: 1px solid $orange;
    color: white;

    &:hover {
      background-color: $black;
      //background-color: $c-alto;
      border: 1px solid $black;
      color: white;
    }

    &:focus {
      background-color: $black;
      border: 1px solid $black;
      color: white;
    }
  }

  &.-white {
    background-color: white;

    &:hover {
      background-color: $c-alabaster;
    }

    &:focus {
      background-color: $orange;
      color: white;
    }
  }

  .default-icon {
    height: 12px;
    position: absolute;
    right: calc(12px + 6px);
    width: 6px;
  }

  &.-transparent {
    background-color: white;
    border: 1px solid black;
    color: black;

    &:hover {
      background-color: $gray;
      border: 1px solid $gray;
      color: black;
    }

    &:focus {
      background-color: $orange;
      border: 1px solid $orange;
      color: white;
    }
  }
}

</style>
